<template>
  <div id="app">
    <iframe src="mms3d/index.html" frameborder="0" id="iframe" ref="mms3D"></iframe>
    <div class="background" v-if="objectoK"></div>
    <!-- 2D -->
    <div class="header" v-if="objectoK">
      <div class="title">
        <div class="main">木棉树港口国际码头海关查验中心3D可视化系统</div>
        <div class="subtitle">The 3D visualization system of the Customs Inspection Center at the International Terminal of Mumianshu Port</div>
      </div>
      <img src="./assets/img/上.gif" alt="" />
      <div class="Menu">
        <div :class="`Menu-item position0 ${path !== 'home' ? '' : 'active'}`"  @click="leap('home')">
          <div :class="`icon ${path === 'home' ? 'active' : ''}`"></div>
          <div :class="`${path === 'home' ? 'active2' : 'text'}`">首页</div>
        </div>
        <div :class="`Menu-item  position1 ${path !== 'electricity' ? '' : 'active'}`"  @click=" leap('electricity')">
            <div :class="`icon ${path === 'electricity' ? 'active' : ''}`"></div> 
            <div :class="`${path === 'electricity' ? 'active2' : 'text'}`">智慧电力</div>
        </div>
        <div :class="`Menu-item  position2 ${path !== 'pipenetwork' ? '' : 'active'}`"  @click="leap('pipenetwork')">
          <div :class="`icon ${path === 'pipenetwork' ? 'active' : ''}`"></div>
          <div :class="`${path === 'pipenetwork' ? 'active2' : 'text'}`">智慧管网</div>
        </div>
        <div :class="`Menu-item  position3 ${path !== 'maintain' ? '' : 'active'}`"  @click="leap('maintain')">
          <div :class="`icon ${path === 'maintain' ? 'active' : ''}`"></div>
          <div :class="`${path === 'maintain' ? 'active2' : 'text'}`">智慧运维</div>
        </div>
        <div :class="`Menu-item  position4 ${path !== 'monitor' ? '' : 'active'}`"  @click="leap('monitor')">
          <div :class="`icon ${path === 'monitor' ? 'active' : ''}`"></div>
          <div :class="`${path === 'monitor' ? 'active2' : 'text'}`">视频监控</div>
        </div>
        
      </div>
      <div class="time">
        <div class="m m1">
          <div>南风3-4级</div>
          <div>湿度40%</div>
        </div>
        <div class="m m2">
          <div>23°C-36°C</div>
          <div>晴转多云</div>
        </div>
        <div class="m m3">
          <div>{{time1}}</div>
          <div>{{time2}}</div>
        </div>
      </div>
    </div>
    <div class="page-content" v-if="objectoK">
      <router-view ></router-view>
      <div class="caozuo-box" v-if="iotIconstate || path === 'pipenetwork'">
        
        <div :class="allIconState ? 'a1 active' : 'a1' "  v-if="Object.keys(IconState2[path][visualAngle]).length >1"  @click="caozuoFn(-1)"></div>
        <div :class="IconState2[path][visualAngle][0] ? allIconState ? 'a2 active ' : 'a2 active position' : 'a2 position' " v-if="path === 'electricity' || path === 'home'" @click="caozuoFn(0)"></div>
        <div :class="IconState2[path][visualAngle][1] ? allIconState ? 'a3 active ' : 'a3 active position'  : 'a3 position' " v-if="path === 'electricity' || path === 'home'" @click="caozuoFn(1)"></div>
        <div :class="IconState2[path][visualAngle][2] ? allIconState ? 'a4 active ' : 'a4 active position'  : 'a4 position' " v-if="path === 'pipenetwork'" @click="caozuoFn(2)"></div>
        <div :class="IconState2[path][visualAngle][3] ? allIconState ? 'a5 active ' : 'a5 active position'  : 'a5 position' " v-if="(path === 'maintain' || path === 'home') && (visualAngle === 'fire' || visualAngle === 'equipment' )" @click="caozuoFn(3)"></div>
        <!-- <div :class="IconState[4] ? allIconState ? 'a6 active ' : 'a6 active position'  : 'a6 position' " v-if="path === 'maintain' || path === 'home'" @click="caozuoFn(4)"></div> -->
        <div :class="IconState2[path][visualAngle][4] ? allIconState ? 'a6 active ' : 'a6 active position'  : 'a6 position' " v-if="(path === 'monitor' || path === 'home')  && visualAngle !== 'fire'" @click="caozuoFn(4)"></div>
        <div :class="energy ? 'a7 active ' : 'a7' " v-if="path === 'electricity' " @click="caozuoFn(6)" ></div>
      </div>
    </div>
    <div id="right" v-if="objectoK">
      <div class="pop1" v-if="optionState">
        <div :class="`li ${modelactiveCount>=6 && !item.active ? 'pointer-events' : '' }`" v-for="(item,i) in modelState" :key="item.id" @click="optionActive(i)">
          <div :class="`no ${item.active ? 'ok' : ''}`"></div>
          <div class="text">{{item.name}}</div>
        </div>
        <div class="btn-box">
          <div class="left" @click="optionNobtn"><span>取消</span></div>
          <div class="right" @click="optionOkbtn"><span>确认</span></div>
        </div>
      </div>
      <div class="option"  @click="operationIcon(1)">
        <div :class="`icon ${optionState ? 'icon2' : ''}`"></div>
        <div class="text">面板配置</div>
        
      </div>
      <div :class="path === 'pipenetwork' ? 'check pointer-events' : 'check'"  @click="operationIcon('check')">
        <div :class="`icon  ${visualAngle === 'check' ? 'icon2' : ''}`"></div>
        <div class="text">海关查验库</div>
      </div>
      <div  :class="path === 'pipenetwork' ? 'detect pointer-events' : 'detect'"  @click="operationIcon('detect')">
        <div :class="`icon ${visualAngle === 'detect' ? 'icon2' : ''}`"></div>
        <div class="text">检测大厅</div>
      </div>
      <div  :class="path === 'pipenetwork' ? 'fire pointer-events' : 'fire'"  @click="operationIcon('fire')">
        <div :class="`icon ${visualAngle === 'fire' ? 'icon2' : ''}`"></div>
        <div class="text">消防水泵房</div>
      </div>
      <div  :class="path === 'pipenetwork' ? 'equipment pointer-events' : 'equipment'"  @click="operationIcon('equipment')">
        <div :class="`icon ${visualAngle === 'equipment' ? 'icon2' : ''}`"></div>
        <div class="text">设备用房</div>
      </div>
      <div class="overview"  equipment  @click="operationIcon('overview')">
        <div :class="`icon ${visualAngle === 'overview' ? 'icon2' : ''}`"></div>
        <div class="text">全览</div>
      </div>
    </div>
    <div class="border-left" v-if="objectoK"></div>
    <div class="border-right" v-if="objectoK"></div>
  </div>
</template>

<script>
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
import moment from 'moment'
import 'moment/locale/zh-cn'
export default {
    data() {
        return {
          path:'',
          time1:'',
          time2:'',
          objectoK:false,
          // 面板配置图标状态
          optionState:false,
          // 视角状态
          visualAngle:'overview',
          modelState:[],
          modelactiveCount:0,
          // '全部' iot设备的状态
          allIconState:false,
          // iot设备状态
          IconState:[false,false,false,false,false],
          IconState2:{
            "home":{
              "check":{
                0:false,
                1:false,
                4:false
              },
              "detect":{
                0:false,
                1:false,
                4:false
              },
              "fire":{
                0:false,
                1:false,
                3:false,
              },
              "equipment":{
                0:false,
                1:false,
                3:false,
                4:false
              },
              "overview":{

              }
            },
            "electricity":{
              "check":{
                0:false,
                1:false,
              },
              "detect":{
                0:false,
                1:false,
              },
              "fire":{
                0:false,
                1:false,
              },
              "equipment":{
                0:false,
                1:false,
              },
              "overview":{

              }
            },
            "pipenetwork":{
              "check":{
                2:false,
              },
              "detect":{
                2:false,
              },
              "fire":{
                2:false,
              },
              "equipment":{
                2:false,
              },
              "overview":{
                2:false,
              }
              
            },
            "maintain":{
              "check":{
              },
              "detect":{
              },
              "fire":{
                3:false,
              },
              "equipment":{
                3:false,
              },
              "overview":{

              }
            },
            "monitor":{
              "check":{
                4:false,
              },
              "detect":{
                4:false,
              },
              "fire":{
              },
              "equipment":{
              },
              "overview":{

              }
            },
          },
          energy:false,
          a:null,
          iotIconstate:false
        };
    },
    created () {
      window.objectOK = this.objectOK
      window.iotIconCaozuo = this.iotIconCaozuo
      window.iotIconfn = this.iotIconfn
      window.densityMap = this.densityMap
      localStorage.setItem('IconState',JSON.stringify(this.IconState2))
    },
    mounted(){
      
      setInterval(() => {
        this.time1 = moment().format('HH:mm:ss');
        this.time2 = moment().format('YYYY-MM-DD dddd');
      }, 1000);
      
    },
    computed:{
        ...mapState(useStore,["basicData"]),
    },
    methods: {
        ...mapActions(useStore, ['']),
        leap(path){
          if(path === this.path){
            return
          }else{
            this.path = path
            this.allIconState = false;
            this.IconState2 = JSON.parse(localStorage.getItem('IconState'))
            this.$router.push(this.path)
            if(path === 'pipenetwork'){
              this.visualAngle = 'overview'
            }
          }
         if(this.optionState){
          this.operationIcon(1);
         }
        //  console.log(this.path,this.visualAngle);
          this.$refs.mms3D.contentWindow.MMAPI.reset(this.path,this.visualAngle)
        },
        objectOK(){
          this.objectoK = true;
          if(window.location.hash.split('#/')[1]){
            this.leap(window.location.hash.split('#/')[1])
          }else{
            this.leap('home')
          }
        },
        operationIcon(visualAngle){
          switch (visualAngle) {
            case 1:
              this.optionState = true;
              this.modelState = JSON.parse(JSON.stringify(this.basicData.option[this.path]))
              this.modelactiveCount = 0
              this.modelState.forEach(item =>{
                if(item.active){
                  this.modelactiveCount++;
                }
              })
              break;
            default:
              if(this.path === 'pipenetwork' && visualAngle !== 'overview'){
                return
              }
              this.visualAngle = visualAngle;
              this.$refs.mms3D.contentWindow.MMAPI.reset(this.path,this.visualAngle)
              break;
          }
          this.IconState2 = JSON.parse(localStorage.getItem('IconState'))
        },
        optionActive(i){
          this.modelState[i].active = !this.modelState[i].active
          this.modelactiveCount = 0
          this.modelState.forEach(item =>{
            if(item.active){
              this.modelactiveCount++;
            }
          })
          if(this.modelactiveCount <=6){

          }else {
            this.modelState[i].active = !this.modelState[i].active;
            this.modelactiveCount = this.modelactiveCount-1;
          }
          
            
        },
        optionOkbtn(){
          this.basicData.option[this.path] = this.modelState
          this.modelState = JSON.parse(JSON.stringify(this.basicData.option[this.path]))
          this.optionState = false
        },
        optionNobtn(){
          this.optionState = false
        },
        
        // iot设备状态操作
        caozuoFn(a){
          if(a === -1){
            this.allIconState = !this.allIconState;
            if(this.allIconState){
              for (const key in this.IconState2[this.path][this.visualAngle]) {
                this.IconState2[this.path][this.visualAngle][key] = true;
                this.$refs.mms3D.contentWindow.MMAPI.iconAdd(this.visualAngle,Number(key));
              }
            }else{
              for (const key in this.IconState2[this.path][this.visualAngle]) {
                this.IconState2[this.path][this.visualAngle][key] = false;
              }
              this.$refs.mms3D.contentWindow.MMAPI.iconRemove()
            }
          }else{
            if(a === 6){
              this.energy = !this.energy
              this.$refs.mms3D.contentWindow.MMAPI.densityMap(this.energy);
            }else{
              this.IconState2[this.path][this.visualAngle][a] = !this.IconState2[this.path][this.visualAngle][a]
              this.IconState2 = JSON.parse(JSON.stringify(this.IconState2))

              
              if(this.IconState2[this.path][this.visualAngle][a]){
                this.$refs.mms3D.contentWindow.MMAPI.iconAdd(this.visualAngle,a);
              }else{
                this.$refs.mms3D.contentWindow.MMAPI.iconRemove(a);
              }
              let sum = 0;
              for (const key in this.IconState2[this.path][this.visualAngle]) {
                if(this.IconState2[this.path][this.visualAngle][key]){
                  sum++;
                }
              }
              if(Object.keys(this.IconState2[this.path][this.visualAngle]).length === sum){
                this.allIconState = true
              }else{
                this.allIconState = false
              }
            }
            
          }
        },
        iotIconCaozuo(pattern){
          switch (pattern) {
            case 'all-on':
              this.allIconState = true;
              for (const key in this.IconState2[this.path][this.visualAngle]) {
                this.IconState2[this.path][this.visualAngle][key] = true
              }
              break;
            case 'all-off':
            this.allIconState = false;
              for (const key in this.IconState2[this.path][this.visualAngle]) {
                this.IconState2[this.path][this.visualAngle][key] = false
              }
              break;
          
            default:
              break;
          }
        },
        iotIconfn(istrue){
          this.iotIconstate = istrue
        },
        densityMap(istrue){
          this.energy = istrue
        }
    },
};
</script>

<style>
#iframe{
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
}
#app {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: black;
  -moz-user-select:none;/*火狐*/
  -webkit-user-select:none;/*webkit浏览器*/
  -ms-user-select:none;/*IE10*/
  -khtml-user-select:none;/*早期浏览器*/
  user-select:none;
  background:url('@/assets/img/bgc.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
}
.background{
  width: 100vw;
  height: 100vh;
  background: url('@/assets/img/bgc2.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  pointer-events: none; /*上层元素挡住下层元素事件的解决方法 该元素不将成为鼠标事件的目标 */
}
.header{
  width: 100%;
  height: 72px;
  background:url('@/assets/img/组\ 76.png') no-repeat;
  background-size:100% ;
  display: flex;
  position: relative;
}
.header img{
  display: block;
    width: 1920px;
    height: 12px;
    position: absolute;
    right: 0;
    top: 16px;
}
.header .title{
  /* background-color: red; */
  font-family:PangMenZhengDao;
  position: relative;
  width: 752px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header .title .main{
  font-size: 30px;
  position: relative;
  left: 21px;
  -webkit-background-clip: text;
  color: transparent;
  background-image: linear-gradient(to bottom, #ffffff 0%,#ffffff 50%, rgb(0, 81, 255) 100%);
}
.header .title .subtitle{
  font-size: 12px;
  -webkit-transform:scale(0.75);
  position: relative;
  font-family: PangMenZhengDao;
  left: -70px;
}
.page-content{
  flex: 1;
  margin-top: 10px;
  overflow: hidden;
  /* position: relative; */
}

.page-content .caozuo-box {
  position: absolute;
  width: 539px;
  height: 78px;
  top: 87px;
  left: 377px;
  display: flex;
  
  align-items: center;
}
.page-content .caozuo-box >div{
  width: 68px;
  height: 78px;
  margin-right: 10px;
  cursor: pointer;
  transition:  transform 2s;
    -webkit-transition:  -webkit-transform 2s;
}
.page-content .caozuo-box >div:nth-child(2){
  transform: translate(-79px,0px);
  z-index: -1;
}
  
  
.page-content .caozuo-box >div:nth-child(3){
  transform: translate(-157px,0px);
  z-index: -1;
}
.page-content .caozuo-box >div:nth-child(4){
  transform: translate(-233px,0px);
  z-index: -1;
}
.page-content .caozuo-box >div:nth-child(5){
  transform: translate(-309px,0px);
  z-index: -1;
}
.page-content .caozuo-box >div:nth-child(6){
  transform: translate(-385px,0px);
  z-index: -1;
}
.page-content .caozuo-box >div:nth-child(7){
  transform: translate(-461px,0px);
  z-index: -1;
}
.page-content .caozuo-box >div.a7{
  transform: translate(0px,0px) !important;
  z-index: 0 !important;
}
.page-content .caozuo-box .position{
  transform: translate(0px,0px) !important;
  z-index: 0 !important;
}
.page-content .caozuo-box .a1{
  background: url('@/assets/img/全部blue.png') no-repeat;
  background-size: 100% 100%;
  z-index: 10;
}
.page-content .caozuo-box .a1.active{
  background: url('@/assets/img/全部yellow.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a2{
  background: url('@/assets/img/电气火灾blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a2.active{
  background: url('@/assets/img/电气火灾yellow.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a3{
  background: url('@/assets/img/电表blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a3.active{
  background: url('@/assets/img/电表yellow.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a4{
  background: url('@/assets/img/水表blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a4.active{
  background: url('@/assets/img/水表yellow.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a5{
  background: url('@/assets/img/空调blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a5.active{
  background: url('@/assets/img/空调yellow.png') no-repeat;
  background-size: 100% 100%;
}

.page-content .caozuo-box .a6{
  margin: 0;
  background: url('@/assets/img/摄像头blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a6.active{
  background: url('@/assets/img/摄像头yellow.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a7{
  position: absolute;
  top: 98px;
  margin: 0;
  background: url('@/assets/img/能源热圈blue.png') no-repeat;
  background-size: 100% 100%;
}
.page-content .caozuo-box .a7.active{
  background: url('@/assets/img/能源热圈yellow.png') no-repeat;
  background-size: 100% 100%;
}
.Menu{
  width: 1157px;
  position: absolute;
  top: 40px;
  right: 0;
  display: flex;
  /* background: red; */

}
.Menu .position0 .icon{
  background: url('@/assets/img/首页icon.png') no-repeat;
  background-size: 100% 100%;

}
.Menu .position0 .active{
  width: 22px !important;
  height: 23px !important;
  left: 46px !important;
  top:0px !important;
  background: url('@/assets/img/首页icon2.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .active2{
  position: relative;
  left: 50px;
  top: 7px;
  font-size: 14px;
  font-weight: 700;
  color: white;
}
.Menu .position1{
  position: relative;
  left: -25px;
}
.Menu .position1 .icon{
  background: url('@/assets/img/电力icon.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position1 .active{
  width: 22px !important;
  height: 23px !important;
  left: 46px !important;
  top:0px !important;
  background: url('@/assets/img/电力icon2.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position2{
  position: relative;
  left: -50px;
}
.Menu .position2 .icon{
  background: url('@/assets/img/管网icon.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position2 .active{
  width: 22px !important;
  height: 23px !important;
  left: 46px !important;
  top:0px !important;
  background: url('@/assets/img/官网icon2.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position3{
  position: relative;
  left: -75px;
}
.Menu .position3 .icon{
  background: url('@/assets/img/运维icon.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position3 .active{
  width: 22px !important;
  height: 23px !important;
  left: 46px !important;
  top:0px !important;
  background: url('@/assets/img/运维icon2.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position4{
  position: relative;
  left: -100px;
}

.Menu .position4 .icon{
  background: url('@/assets/img/监控icon.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .position4 .active{
  width: 22px !important;
  height: 23px !important;
  left: 46px !important;
  top:0px !important;
  background: url('@/assets/img/监控icon2.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .Menu-item{
  width: 197px;
  height: 42px;
  background: url('@/assets/img/组\ 99\ 拷贝\ 3.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  cursor: pointer;
}
.Menu-item.active{
  background: url('@/assets/img/yellow.png') no-repeat;
  background-size: 100% 100%;
}
.Menu .Menu-item .icon{
  width: 47px;
  height: 42px;
  position: relative;
  left: 35px;
  top: -16px;
}
.Menu .Menu-item .text{
  position: relative;
  left: 35px;
  top: 7px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  -webkit-background-clip: text;
  color: transparent;
  background-image: linear-gradient(to bottom, #ffffff 0%, rgb(0, 81, 255) 100%);
  text-shadow:0 0 1px #fff,0 0 2px #3d91ff,0 0 3px #0842ff,2px 3px 3px rgb(27, 27, 27);
}

.header .time{
      width: 260px;
    /* height: 50px; */
    /* background: red; */
    position: absolute;
    right: 10px;
    bottom: -10px;
    display: flex;
    font-size: 12px;
}
.header .time .m{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header .time .m2{
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}
.header .time .m1,.header .time .m2{
  width: 74px;
    display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header .time .m3{
  flex: 1;
    display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:flex-end;
}
.header .time .m >div{
  line-height: 20px;
}



#right{
  width: 62px;
  height: calc(100vh - 296px - 102px);
  position: absolute;
  top: 92px;
  right: 30px;
  background:url('@/assets/img/a.png') no-repeat;
  background-size: contain;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
#right >div:nth-child(n+2){
  width: 62px;
  height: 80px;
  cursor: pointer;
  /* background-color: salmon; */
} 
#right  .option{
  cursor: pointer;
}
#right  .option .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/面板配置.png') no-repeat;
  background-size: 100% 100%;
}
#right  .option .icon2{
  background: url('@/assets/img/面板配置2.png') no-repeat;
  background-size: 100% 100%;
}
#right  .check .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/海关查验库.png') no-repeat;
  background-size: 100% 100%;
}
#right  .check .icon2{
  background: url('@/assets/img/海关查验库2.png') no-repeat;
  background-size: 100% 100%;
}
#right  .detect .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/检测大厅.png') no-repeat;
  background-size: 100% 100%;
}
#right  .detect .icon2{
  background: url('@/assets/img/检测大厅2.png') no-repeat;
  background-size: 100% 100%;
}
#right  .fire .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/消防水泵房.png') no-repeat;
  background-size: 100% 100%;
}
#right  .fire .icon2{
  background: url('@/assets/img/消防水泵房2.png') no-repeat;
  background-size: 100% 100%;

}
#right  .equipment .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/设备用房.png') no-repeat;
  background-size: 100% 100%;
}
#right  .equipment .icon2{
  background: url('@/assets/img/设备用房2.png') no-repeat;
  background-size: 100% 100%;

}
#right  .overview .icon{
  width: 62px;
  height: 62px;
  background: url('@/assets/img/全览.png') no-repeat;
  background-size: 100% 100%;
}
#right  .overview .icon2{
  background: url('@/assets/img/全览2.png') no-repeat;
  background-size: 100% 100%;
}
#right  .text{
  font-size: 12px;
  margin-top: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.border-left{
  width: 20px;
  height: calc(100vh - 92px);
  position: absolute;
  top: 82px;
  left: 0;
  background: url('@/assets/img/左.gif') no-repeat;
  background-size: 100% 100%;
  /* background-color: #0842ff; */
}
.border-right{
  width: 20px;
  height: calc(100vh - 92px);
  position: absolute;
  top: 82px;
  right: 0;
  background: url('@/assets/img/右.gif') no-repeat;
  background-size: 100% 100%;
  /* background-color: #0842ff; */
}
.border-Row{
  width: 336px;
  height: 10px;
  margin: 10px 0px;
  background:url('@/assets/img/border-Row.png') no-repeat;
  background-size: 100% 100%;
}
.border-column{
  width: 10px;
  height: 276px;
  margin: 0px 20px;
  background:url('@/assets/img/border-column.png') no-repeat;
  background-size: 100% 100%;
}
.echarts-content{
  flex: 1;
  margin-top: 7px;
  /* background-color: red; */
}

/* 面板配置的弹框 */
.pop1{
  width: 179px !important;
  background: url('@/assets/img/弹窗.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: -183px;
  top: 14px;
  display: flex;
  flex-direction: column;
  cursor: default !important;
  padding: 11px 20px;
  box-sizing: border-box;
}
.pop1 .li{
  height: 21px;
  margin: 5px 0px;
  display: flex;
  /* margin-left:24px; */
  align-items: center;
  cursor:pointer ;
}
.pop1 .li .no{
  width: 15px;
  height: 15px;
  background: #94abcd40;
  border: 1.5px solid #94abcd;
  box-sizing: border-box;
  margin-right: 5px;
}
.pop1 .li .ok{
  width: 15px;
  height: 15px;
  border: 1.5px solid #94abcd;
  background: #94abcdda;
  box-sizing: border-box;
  display: flex;
  margin-right: 5px;
  justify-content: center;
  align-items: center;
}
.pop1 .li .text{
  font-size: 12px;
  font-weight: 700;
  margin: 0 !important; 
  -webkit-background-clip: text;
  color: transparent;
  background-image: linear-gradient(to bottom, #ffffff 0%,#ffffff 50%, rgb(0, 81, 255) 100%);
}
.pop1 .btn-box{
  height: 21px;
  display: flex;
  justify-content: space-between;
  margin:5px 0px;
  align-items: center;
  font-size: 12px;
  cursor:pointer ;
}
.pop1 .btn-box .left,
.pop1 .btn-box .right{
  width: 57px;
  height: 19px;
  background: url('@/assets/img/blue-btn.png') no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 19px;
}
.pop1 .btn-box .left:hover,
.pop1 .btn-box .right:hover{
  background: url('@/assets/img/yellow-btn.png') no-repeat;
  background-size: 100% 100%;
  color: #f1ab03;
}
.pop1 .btn-box span{
  display: inline-block;
  transform: scale(.8);
}
.gif{
  position: absolute;
  top: 55px;
  height: 90%;
  width: 5px;
  background: url(@/assets/img/左右.gif) no-repeat;
  background-size: 100% 100%;
}
.pointer-events{
  /* pointer-events:none; */
  cursor:not-allowed !important;
}

#left .placeholder-border{
  width: 338px;
  flex: 1;
  /* background: red; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#left2{
  width: 338px;
  /* height: calc(100vh - 100px); */
  /* background: red; */
  position: absolute;
  top: 82px;
  left: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#left2 .placeholder-border{
  width: 338px;
  height: 276px;
  /* background: red; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.scale{
	transform: scale(.8);
    display: inline-block;
}
.add{
	display: inline-block;
	width: 10px;
	height: 10px;
	background: url('@/assets/img/增加.png') no-repeat;
	background-size: 100% 100%;
  margin-left: 2px;
}
.reduce{
	display: inline-block;
	width: 10px;
	height: 10px;
	background: url('@/assets/img/下降.png') no-repeat;
	background-size: 100% 100%;
	transform: translateY(1px);
  margin-left: 2px;
}
</style>
